export default ([
	{ labelText: 'AA', id: 'AA' },
	{ labelText: 'Adam & Co Investment Management Ltd', id: 'Adam & Co Investment Management Ltd' },
	{ labelText: 'Aldermore plc', id: 'Aldermore plc' },
	{ labelText: 'Bank of Cyprus UK', id: 'Bank of Cyprus UK' },
	{ labelText: 'Bank of Scotland', id: 'Bank of Scotland' },
	{ labelText: 'Barclays Bank plc', id: 'Barclays Bank plc' },
	{ labelText: 'Birmingham Midshires plc', id: 'Birmingham Midshires plc' },
	{ labelText: 'Brent Shrine Credit Union Ltd', id: 'Brent Shrine Credit Union Ltd' },
	{ labelText: 'Britannia', id: 'Britannia' },
	{ labelText: 'Charter Court Financial Services', id: 'Charter Court Financial Services' },
	{ labelText: 'Chelsea Building Society', id: 'Chelsea Building Society' },
	{ labelText: 'Cheltenham & Gloucester', id: 'Cheltenham & Gloucester' },
	{ labelText: 'Chorley & District Building Society', id: 'Chorley & District Building Society' },
	{ labelText: 'Co-operative Bank plc', id: 'Co-operative Bank plc' },
	{ labelText: 'Coutts & Co', id: 'Coutts & Co' },
	{ labelText: 'Coventry Building Society', id: 'Coventry Building Society' },
	{ labelText: 'Cumberland Building Society', id: 'Cumberland Building Society' },
	{ labelText: 'Danske Bank', id: 'Danske Bank' },
	{ labelText: 'Darlington Building Society', id: 'Darlington Building Society' },
	{ labelText: 'Family Equity Plan Ltd', id: 'Family Equity Plan Ltd' },
	{ labelText: 'FCE Bank plc - Ford Money', id: 'FCE Bank plc - Ford Money' },
	{ labelText: 'First Direct', id: 'First Direct' },
	{ labelText: 'First Trust Bank', id: 'First Trust Bank' },
	{ labelText: 'Halifax plc', id: 'Halifax plc' },
	{ labelText: 'HSBC Bank plc', id: 'HSBC Bank plc' },
	{ labelText: 'HSBC Bank plc - Global Investment Centre', id: 'HSBC Bank plc - Global Investment Centre' },
	{ labelText: 'HSBC Bank plc - InvestDirect and First Direct Sharedealing ISAs', id: 'HSBC Bank plc - InvestDirect and First Direct Sharedealing ISAs' },
	{ labelText: 'HSBC Private Bank (UK) Ltd ', id: 'HSBC Private Bank (UK) Ltd ' },
	{ labelText: 'HSBC Trust Co (UK) Ltd', id: 'HSBC Trust Co (UK) Ltd' },
	{ labelText: 'Intelligent Finance', id: 'Intelligent Finance' },
	{ labelText: 'Leeds Building Society', id: 'Leeds Building Society' },
	{ labelText: 'Lloyds Bank plc', id: 'Lloyds Bank plc' },
	{ labelText: 'M&S Bank', id: 'M&S Bank' },
	{ labelText: 'Market Harborough Building Society', id: 'Market Harborough Building Society' },
	{ labelText: 'National Westminster Bank plc', id: 'National Westminster Bank plc' },
	{ labelText: 'Nationwide Building Society', id: 'Nationwide Building Society' },
	{ labelText: 'Newcastle Building Society', id: 'Newcastle Building Society' },
	{ labelText: 'Nottingham Building Society', id: 'Nottingham Building Society' },
	{ labelText: 'Paragon Bank Limited', id: 'Paragon Bank Limited' },
	{ labelText: 'Progressive Building Society', id: 'Progressive Building Society' },
	{ labelText: 'Royal Bank of Scotland plc', id: 'Royal Bank of Scotland plc' },
	{ labelText: 'SAGA', id: 'SAGA' },
	{ labelText: 'Sainsbury\'s Bank', id: 'Sainsbury\'s Bank' },
	{ labelText: 'Santander UK Plc', id: 'Santander UK Plc' },
	{ labelText: 'Scottish Widows Bank plc', id: 'Scottish Widows Bank plc' },
	{ labelText: 'Skipton Building Society', id: 'Skipton Building Society' },
	{ labelText: 'St James Place Bank', id: 'St James Place Bank' },
	{ labelText: 'State Bank of India', id: 'State Bank of India' },
	{ labelText: 'Swansea Building Society', id: 'Swansea Building Society' },
	{ labelText: 'Tesco Personal Finance plc', id: 'Tesco Personal Finance plc' },
	{ labelText: 'TSB Bank PLC', id: 'TSB Bank PLC' },
	{ labelText: 'Ulster Bank Ltd', id: 'Ulster Bank Ltd' },
	{ labelText: 'Virgin Money plc', id: 'Virgin Money plc' },
	{ labelText: 'West Bromwich BS (WeBSave)', id: 'West Bromwich BS (WeBSave)' },
	{ labelText: 'West Bromwich Building Society', id: 'West Bromwich Building Society' },
	{ labelText: 'Yorkshire Building Society', id: 'Yorkshire Building Society' },
	{ labelText: 'Other', id: 'Other' },
]);
